import { FETCH_STORAGE_LOCATION, FETCH_STORAGE_LOCATION_FULFILLED, FETCH_STORAGE_LOCATION_REJECTED } from '../actions'

export default (state = {
  data: null,
  fetching: false,
  fetched: false,
  error: null
}, action) => {
  switch (action.type) {
    case FETCH_STORAGE_LOCATION:
      return { ...state, fetching: true, fetched: false, error: null }
    case FETCH_STORAGE_LOCATION_FULFILLED:
      const payload = action.payload
      return { ...state, fetching: false, fetched: true, error: null, data: payload }
    case FETCH_STORAGE_LOCATION_REJECTED:
      return { ...state, fetching: false, fetched: false, error: action.payload, data: null }

    default:
      return state
  }
}
